import DropDown from '../../../components/DropDown';

const DateRangeToggle = ({ value, onChange, dateRanges }) => {

	const displayTimeFrame = (time) => {
		if (!time || typeof time === "string") return "All Time"
		let string = `${time.months ? time.months === 1 ? "1 Month" : time.months + " Months" : ""} ${time.days ? time.days === 1 ? "1 Day" : time.days + " Days" : ""} ${time.years ? time.years === 1 ? "1 Year" : time.years + " Years" : ""}`
		return string
	}

	return (
		dateRanges && typeof dateRanges === 'object' && dateRanges.length > 0 &&
			<DropDown fixed value={value} transparent clickable minMenuWidth={100} placement='bottom-end'>
				{dateRanges.map(r => <li key={displayTimeFrame(r)} onClick={() => onChange(r)}>{displayTimeFrame(r)}</li>)}
			</DropDown>
	);
}

export default DateRangeToggle;